import { useSelector } from 'react-redux';
import { AppState } from '../../redux/AppState';
import { Modal } from '../common/modal/Modal';

export const Modals = () => {
  const modal = useSelector((state: AppState) => state.app.modal);

  return <div>{modal && <Modal {...modal} />}</div>;
};
